import {Pipe, PipeTransform} from '@angular/core';
import {TemplateRole} from '../../main/pages/documents/dto/document-details.dto';

@Pipe({
  name: 'extractSenderDetailPipe',
  standalone: true,
})

/**
* Extract sender role from template roles
*/
export class ExtractSenderDetailPipe implements PipeTransform {
  transform(templateRoles: TemplateRole[]): TemplateRole {
    if(!templateRoles) return {} as TemplateRole;
    const senderRole = templateRoles.find(x  => x?.recipient_role_detail?.is_sender === 1);
    return senderRole ?? {} as TemplateRole;
  }
}
